import { useEffect, useState } from "react"
import "./list1.css"

const List = () => {
  const [rows, setRows]       = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [hotelsRes, cafesRes] = await Promise.all([
          fetch("https://api.moroccool.com/api/hotels"),
          fetch("https://api.moroccool.com/api/cafes"),
        ])
        const hotels = await hotelsRes.json()
        const cafes  = await cafesRes.json()

        const combined = [
          ...hotels.map(h => ({ ...h, _itemType: "hotel" })),
          ...cafes.map(c => ({ ...c, _itemType: "cafe" })),
        ]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 10)

        setRows(combined)
      } catch (err) {
        console.error("List fetch error:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "—"

  const formatDate = (dateStr) => {
    if (!dateStr) return "—"
    const d = new Date(dateStr)
    const today = new Date()
    const diff  = Math.floor((today - d) / 86400000)
    if (diff === 0) return "Aujourd'hui"
    if (diff === 1) return "Hier"
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })
  }

  if (loading) {
    return (
      <div className="list-loading">
        <div className="list-spinner" />
      </div>
    )
  }

  return (
    <div className="list-root">
      <div className="list-table-wrap">
        <table className="list-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Type</th>
              <th>Ville</th>
              <th>Adresse</th>
              <th>Téléphone</th>
              <th>Créé le</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row._id || row.id} className="list-row">
                <td className="td-name">
                  {row.logo && (
                    <img
                      src={row.logo}
                      alt={row.name}
                      className="row-avatar"
                    />
                  )}
                  <span>{row.name || "—"}</span>
                </td>
                <td>
                  <span className={`type-badge type-${row._itemType}`}>
                    {row._itemType === "hotel" ? "Hôtel" : "Café"}
                  </span>
                </td>
                <td className="td-muted">{capitalize(row.city)}</td>
                <td className="td-address">{row.location || "—"}</td>
                <td className="td-muted">{row.phone || "—"}</td>
                <td className="td-date">{formatDate(row.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default List